/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careful_Whole_Hyena_StriveInputs */

const fr_careful_whole_hyena_strive = /** @type {(inputs: Careful_Whole_Hyena_StriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas les droits pour effectuer cette action`)
};

/**

* @param {Careful_Whole_Hyena_StriveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const careful_whole_hyena_strive = /** @type {((inputs?: Careful_Whole_Hyena_StriveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careful_Whole_Hyena_StriveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_careful_whole_hyena_strive(inputs)
});